import { createSlice } from "@reduxjs/toolkit";
import {
  signupDoctor,
  verifyDoctorOtp,
} from "../../Thunk/doctorAuthThunk/doctorAuthThunk";

const initialState = {
  signupLoading: false,
  verifyLoading: false,
  error: null,
  signupSuccess: false,
  verifySuccess: false,
  pendingSignupMobile: "",
  uploadedKeys: null,
};

const doctorAuthSlice = createSlice({
  name: "doctorAuth",
  initialState,
  reducers: {
    clearDoctorAuthError: (state) => {
      state.error = null;
    },
    resetDoctorSignupState: (state) => {
      state.signupLoading = false;
      state.verifyLoading = false;
      state.error = null;
      state.signupSuccess = false;
      state.verifySuccess = false;
      state.pendingSignupMobile = "";
      state.uploadedKeys = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signupDoctor.pending, (state) => {
        state.signupLoading = true;
        state.error = null;
        state.signupSuccess = false;
      })
      .addCase(signupDoctor.fulfilled, (state, action) => {
        state.signupLoading = false;
        state.signupSuccess = true;
        state.pendingSignupMobile = action.payload?.mobile || "";
        state.uploadedKeys = action.payload?.uploadedKeys || null;
      })
      .addCase(signupDoctor.rejected, (state, action) => {
        state.signupLoading = false;
        state.signupSuccess = false;
        state.error = action.payload || "Doctor signup failed";
      })

      .addCase(verifyDoctorOtp.pending, (state) => {
  state.verifyLoading = true;
  state.error = null;
  state.verifySuccess = false;
})
.addCase(verifyDoctorOtp.fulfilled, (state, action) => {
  state.verifyLoading = false;
  state.verifySuccess = true;
  state.error = null;
})
.addCase(verifyDoctorOtp.rejected, (state, action) => {
  state.verifyLoading = false;
  state.verifySuccess = false;
  state.error = action.payload || "OTP verification failed";
});
  },
});

export const { clearDoctorAuthError, resetDoctorSignupState } =
  doctorAuthSlice.actions;

export default doctorAuthSlice.reducer;
